<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full tw-p-5">
            <h2>Merci</h2>
            <p>Un conseiller va vous appeler d’ici 15 minutes afin de finaliser votre demande de rendez-vous.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    background-color: $main_color;
    color: $white;

    @screen md {
        max-width: 460px;
    }
}

</style>
